import { render } from "./performance-appraisal.vue?vue&type=template&id=0fe4031d"
import script from "./performance-appraisal.vue?vue&type=script&lang=js"
export * from "./performance-appraisal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__